import TextPollItem, { PollItemProps } from "./TextPollItem";

export type ImagePollItemProps = PollItemProps & {
    img: string;
};

const ImagePollItem = ({
    percent,
    img,
    className,
    style
}: ImagePollItemProps) => {
    return (
        <div
            className={`image-poll-item flex flex-col items-center justify-start gap-3 ${className}`}
            style={style}
        >
            <TextPollItem percent={percent} />
            <img src={img} alt="poll-image" />
        </div>
    );
};

export default ImagePollItem;
